import { render } from "./BaseAudioElement.vue?vue&type=template&id=513e91c4&scoped=true&ts=true"
import script from "./BaseAudioElement.vue?vue&type=script&lang=ts"
export * from "./BaseAudioElement.vue?vue&type=script&lang=ts"

import "./BaseAudioElement.vue?vue&type=style&index=0&id=513e91c4&lang=scss&scoped=true"

import exportComponent from "D:\\zhangjc\\zhangjc_pro\\Edensoft.AIManage\\Edensoft.AIManageGit\\Edensoft.AIManage\\Edensoft.AIManage.PPTCopilot.PPTist.Apache-2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-513e91c4"]])

export default __exports__